import {formatAndLayoutSeats} from "./formatAndLayoutSeats";

/**
 * Glavna funkcija koja obrađuje sve podatke, grupiše ih i formatira.
 * @param {Array} allSeats - Originalni niz svih sedišta za sve autobuse.
 * @param {Boolean} isSelfSale - Da li je sopstvena prodaja.
 */
export const processBusData = (allSeats, isSelfSale) => {

    const vehicles = allSeats.reduce((acc, seat) => {
        if (!acc[seat.vehicleId]) {
            acc[seat.vehicleId] = {
                id: seat.vehicleId,
                plate: seat.plateNumber,
                seatsData: []
            };
        }
        acc[seat.vehicleId].seatsData.push(seat);
        return acc;
    }, {});

    return Object.values(vehicles).map(vehicle => {
        return {
            id: vehicle.id,
            plate: vehicle.plate,
            seats: formatAndLayoutSeats(vehicle.seatsData, isSelfSale)
        };
    });
};
